var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCharcoalBackWheels1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 466,
    height: 71,
    viewBox: "0 0 466 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 430.043,
    cy: 35.3833,
    r: 29.9398,
    fill: "black",
    stroke: "#AAAAAA",
    strokeWidth: 10.8872
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.399,
    cy: 35.3833,
    r: 29.9398,
    fill: "black",
    stroke: "#AAAAAA",
    strokeWidth: 10.8872
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.362,
    cy: 35.3833,
    r: 29.9398,
    fill: "black",
    stroke: "#AAAAAA",
    strokeWidth: 10.8872
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.3833,
    cy: 35.3833,
    r: 29.9398,
    fill: "black",
    stroke: "#AAAAAA",
    strokeWidth: 10.8872
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 421.879,
    cy: 35.3833,
    r: 29.9398,
    fill: "#AAAAAA",
    stroke: "black",
    strokeWidth: 10.8872
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.196,
    cy: 35.3833,
    r: 29.9398,
    fill: "#AAAAAA",
    stroke: "black",
    strokeWidth: 10.8872
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharcoalBackWheels1);
export default __webpack_public_path__ + "static/media/charcoal-back-wheels1.7d752dacffd039329c42747495debbb4.svg";
export { ForwardRef as ReactComponent };